import { render, staticRenderFns } from "./La0.vue?vue&type=template&id=350bf11e&scoped=true&"
import script from "./La0.vue?vue&type=script&lang=js&"
export * from "./La0.vue?vue&type=script&lang=js&"
import style0 from "./La0.vue?vue&type=style&index=0&id=350bf11e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350bf11e",
  null
  
)

export default component.exports